// Components==============
import ColorProfile from 'components/UI/ColorProfile/ColorProfile';
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import { GrowthPortfolioContext } from 'pages/Growth/GrowthPortfolio/GrowthPortfolio';
import React, { useContext } from 'react';
import { framerMountAndScale } from 'utilities/FramerAnimations';
import './Colors.module.scss';
// =========================

export default function Colors() {
  const translate = useTranslate();

  const data = useRedux((state) => state.authentication?.user?.color_profile);

  const { setSelected } = useContext(GrowthPortfolioContext);

  return (
    <div styleName="wrapper">
      {data ? (
        <ColorProfile
          data={data}
          onClick={() => setSelected('reflection.terms.color-profile')}
          delay
        />
      ) : (
        <motion.div
          {...framerMountAndScale}
          styleName="color-profile"
          onClick={() => setSelected('reflection.terms.color-profile')}
        >
          <img src="/images/kleurenprofiel-default.svg" alt="kleuren profiel" />
          <h2>{translate('reflection.terms.my-color-profile')}</h2>
        </motion.div>
      )}
      <h3>{translate('project.terms.phases')}</h3>
    </div>
  );
}
